export const percent = (value: number) => {
  const option = {
    style: 'percent' as const,
    maximumFractionDigits: 2,
  };

  // For numbers with absolute value less than 1, multiply by 100 to get the correct percentage
  // For numbers with absolute value greater than or equal to 1, use the value directly
  const normalizedValue = Math.abs(value) < 1 ? value : value / 100;

  const formatter = Intl.NumberFormat('en-US', option).format(normalizedValue);

  return formatter;
};

export const UsdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',  
});